module.exports = __webpack_public_path__ + "img/EURS.c6b54bc5.svg";